import React from "react";
import { useNavigate } from "react-router-dom";

const SumarMiNegocio = () => {
  const navigate = useNavigate();

  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">Suma tu negocio a QRBenefits</h1>
      <p className="text-secondary mb-4">
        Atrae nuevos clientes, fideliza a los actuales y administra tus beneficios desde un panel intuitivo.
      </p>

      <h4 className="fw-bold mt-4">Que puedes hacer?</h4>
      <ul className="fs-5 mt-2">
        <li>Crear beneficios en minutos.</li>
        <li>Mostrar un QR en tu local listo para usar.</li>
        <li>Recibir resenas de tus clientes.</li>
        <li>Ver estadisticas de uso real.</li>
      </ul>

      <div className="d-flex gap-2 flex-wrap mt-4">
        <button className="btn btn-primary" onClick={() => navigate("/register")}>
          Comenzar el registro
        </button>

        <button
          className="btn btn-outline-primary"
          onClick={() => navigate("/contacto-comercios")}
        >
          Quiero que me contacten
        </button>
      </div>
    </div>
  );
};

export default SumarMiNegocio;
